// extracted by mini-css-extract-plugin
module.exports = {"dialog":"ModalUI_dialog__3vtpl","dialogTitle":"ModalUI_dialogTitle__i9l7q","divitem":"ModalUI_divitem__28DMX","timePickerInput":"ModalUI_timePickerInput__2qpQr"};